var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IntegrationPageLayout',{attrs:{"tag":"facebook"}},[_c('PageContainer',[_c('div',{staticClass:"iqos-grid"},[(_vm.selected == 'facebook')?_c('div',{staticClass:"iqos-column"},[_c('FacebookPixelPanel')],1):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }